<template>
  <div style="margin-bottom:30px;">
    <el-form-item :prop="elementDefinition.key" :label="elementDefinition.label">
      <el-upload v-if="edit_mode !== false"
          :on-success="afterSuccessfulUpload"
          :on-remove="afterRemove"
          :on-change="handleListChange"
          :file-list="fileList"
          action="/api/uploads">
        <el-button size="small" type="primary" style="float:left;">Click to upload</el-button>
      </el-upload>
      <div v-else class="form-readonly-value">
        {{ getImageDisplayText() }}
      </div>
    </el-form-item>
    </div>
</template>

<script>
    export default {
        name: "FormElementImage",
        props: [
            'elementDefinition',
            'initialValue',
            'handleFormElementValueChange',
            'edit_mode'
        ],
        data() {
            return {
                selectedValue: null,
                fileList: [],
                original_filename: '',
            }
        },
        mounted() {
        },
        methods: {
            handleListChange(file,fileList) {
              this.original_filename = file.name
            },
            afterSuccessfulUpload(response) {
                let field_name = this.elementDefinition.key
                let field_value = {
                  temp_filename: response,
                  original_filename: this.original_filename
                }
                this.$emit('handleFormElementValueChange', {field_value, field_name})
            },
            getImageDisplayText() {
                if (this.initialValue && this.initialValue.original_filename) {
                    return this.initialValue.original_filename
                }
                return '(no image uploaded)'
            },
            afterRemove() {
              // noop
            }
        },
        watch: {
          initialValue: function(val) {
            this.fileList = []
          }
        },
    }
</script>

<style scoped>

</style>